export const FEATURE_FLAGS = {
	FreeTrial: true,
};

export function isFeatureEnabled(feature: keyof typeof FEATURE_FLAGS) {
	return FEATURE_FLAGS[feature];
}
